module.exports = __webpack_public_path__ + "img/ES.f7d62886.png";